// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"372":"a6038e9a","535":"a41dd519"}[chunkId] + ".chunk.js";
};